// extracted by mini-css-extract-plugin
export default {"ErrorElement":"ErrorElement_ErrorElement__+-jyl"};